import api from './axios';

// 강좌·콘텐츠
// VLab 강좌 조회
export const getVLabList = async (userData) => {
  const response = await api.post('/knouUser/clss/getVLabList', userData);
  return response.data;
};

// VLab 강좌 상세정보 조회
export const getVLabDetail = async (userData) => {
  const response = await api.post('/knouUser/clss/getVLabDetail', userData);
  return response.data;
};

//VLab 강좌 - 강좌 소개
export const fetchLectureIntroduce = async (params) => {
  const response = await api.get('/knouUser/clss/getLectureIntroduce', params);
  return response.data;
};

// VLab 강좌 상세정보 - 강좌-섹션-강의목록 조회
export const getVLabLectureSectionCourse = async (params) => {
  const response = await api.get('/knouUser/clss/getLectureForSectionCourse', params);
  return response.data;
};

// VLab 강좌 - 강좌수강신청
export const insertVLabLectureReserve = async (params) => {
  const response = await api.post('/knouUser/clss/insertLectureTrainee', params);
  return response.data;
};

// XR콘텐츠 조회
export const getXrCntsList = async (userData) => {
  const response = await api.post('/knouUser/clss/getXrCntsList', userData);
  return response.data;
};

// XR콘텐츠 상세정보 조회
export const getXrCntsDetail = async (userData) => {
  const response = await api.post('/knouUser/clss/getXrCntsDetail', userData);
  return response.data;
};

// XR콘텐츠 - 내가본컨텐츠내역 insert
export const insertXrCntsHistory = async (userData) => {
  const response = await api.post('/knouUser/clss/insertMyContentsHistory', userData);
  return response.data;
};

// VLab 강좌 상세정보 - 강좌계획서 가져오기
export const getVLabLectureAttachFile = async (params) => {
  const response = await api.get('/knouUser/clss/getLectureAttachFile', params);
  return response.data;
};



